module.exports = __webpack_public_path__ + "img/team.9c2f1c49.svg";